// src/API/books.js
import {statusOptions} from "../Components/Utils/constants";
import {fetchGet, fetchPatch, fetchPost, fetchPut, postFormMultiMediaData} from "./util";

export const getBooks = ({results, search, columns, offset, sortBy, order, status}) => {
    const searchQuery = search ? `${search}` : "";
    const sb = sortBy ? `&sortBy=${encodeURIComponent(sortBy)}` : "";
    const ord = order ? `&order=${encodeURIComponent(order)}` : "";
    const stat = status ? `&status=${encodeURIComponent(status)}` : "";
    return fetchGet(
        `/books?results=${results}${searchQuery}&columns=${columns}&offset=${offset}${stat}${sb}${ord}`
    ).then((res) => res);
};

export const getActiveBooks = () => {
    return fetchGet("/books?status=active").then((res) => res);
};

export const getBookDetails = ({id, columns}) => {
    return fetchGet(`/books/${id}?columns=${columns}`).then((res) => res);
};

export const createBook = (data) => {
    // Mirror PATCH shape: { obj: data }
    return fetchPost(`/books`, data).then((res) => res);
};

export const updateBook = ({id, obj}) => {
    return fetchPut(`/books/${id}`, obj).then((res) => res);
};

export const archiveBook = (id) => {
    return fetchPatch(`/books/${id}/archive`, {}).then((res) => res);
};

export const restoreBook = (id) => {
    return fetchPatch(`/books/${id}/restore`).then((res) => res);
};

export const bulkImportBooks = (file) => {
    const form = new FormData();
    form.append("file", file);
    return postFormMultiMediaData("/books/import/csv", form);
};

export const getPendingOrdersCount = () => {
    return fetchGet(`/book-orders?status=${statusOptions.pending_review}&results=1`).then((res) => res);
};

export const getBookImportHistory = async () => {
    return fetchGet('/books/imports/history');
};